import { SET_USER_DISCLOSURES, REMOVE_USER_DISCLOSURES } from "../types";

export const setDisclosures = (userDisclosures) => ({
  type: SET_USER_DISCLOSURES,
  userDisclosures,
});

export const setUserDisclosures = (userDisclosures) => (dispatch) => {
  dispatch(setDisclosures({ userDisclosures }));
};

export const removeUserDisclosures = () => ({
  type: REMOVE_USER_DISCLOSURES,
});

export const resetUserDisclosures = () => (dispatch) => {
  dispatch(removeUserDisclosures());
};



// WEBPACK FOOTER //
// ./src/actions/userDisclosures.js